// Route recommendation (contracts.md registry row "Route recommendation"; ADR-0016 §1;
// workflows.md:27; D33).
//
// A recommendation shaped by the founder's stated intent AND the fingerprint, never the fingerprint
// alone (D33). payments/auth/PII force a required, non-toggleable environment floor. INVARIANT (D27):
// there is NO cost/token/price field - the route card is a customer-facing surface. recommendRoute()
// lives in @nightcrew/connections (Wave 2); this is the frozen shape it returns. Confirmation
// materializes `environments` + `apps.route_confirmed_at`; there is no `route_cards` table (ADR-0016 §1).
import { z } from "zod";
import { NonEmptyString } from "./common.js";
import { AppIntent, Cloud, EnvironmentType } from "./enums.js";
import { FingerprintSummary } from "./fingerprint.js";
/** The ordered stations a route can include (workflows.md:27). */
export const RouteStation = z.enum([
    "baseline_audit",
    "certify",
    "build",
    "production_build",
    "migration",
    "run",
]);
/** One environment the route recommends. `toggleable` is false when the fingerprint floor pins it on. */
export const EnvironmentRecommendation = z.object({
    type: EnvironmentType,
    enabled: z.boolean(),
    required: z.boolean(),
    toggleable: z.boolean(),
});
/** The inputs the recommendation is a pure function of. */
export const RouteRecommendationInput = z.object({
    intent: AppIntent,
    fingerprint: FingerprintSummary,
    cloud: Cloud.nullable(),
    region: NonEmptyString.nullable(),
});
/** The recommendation surfaced to the founder for a one-tap confirm. No cost/token/price by construction (D27). */
export const RouteRecommendation = z.object({
    stations: z.array(RouteStation),
    environments: z.array(EnvironmentRecommendation),
    /** Why a floor was applied (payments/auth/PII), or null when none. An audit string, no PII. */
    floorReason: NonEmptyString.nullable(),
    /** True when the target cloud/region was validated as reachable and supported. */
    cloudValidated: z.boolean(),
});
//# sourceMappingURL=route.js.map